'use client';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';

import { IS_PREVIEW } from '@src/typescriptGlobals/constants';

import { store } from '@src/redux/store/store';

/**
 * Providers component that wraps the application with ReduxProvider.
 * Add more providers here if needed.
 */
const Providers: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <ContentfulLivePreviewProvider
        locale='en-US'
        enableInspectorMode={false} // disable inspector (no mouse-move queries)
        enableLiveUpdates={IS_PREVIEW} // only stream updates when flag is true
        debugMode={false} // turn off SDK debug logs
        targetOrigin='https://app.contentful.com'
      >
        <ReduxProvider store={store}>{children}</ReduxProvider>
      </ContentfulLivePreviewProvider>
    </>
  );
};

export default Providers;
